export const CLOSED = "closed";
export const ISCLOSED = "isclosed";
export const OPENED = "opened";

export const ADMIN_DASHBOARD = "adminDashboard";
export const ADMIN_NEW = "adminNews";
export const ADMIN_HISTORY = "adminHistories";
export const ADMIN_USERS = "adminUsers";
export const ADMIN_GUIDE = "adminGuide";
export const ADMIN_VOUCHER = "adminVouchers";
export const ADMIN_VOUCHER_HISTORY = "adminVoucherHistories";
export const ADMIN_RATE_LIMIT = "adminRateLimit";
export const ADMIN_CHAT = "adminChat";
export const ADMIN_ITEM_USAGE = "adminItemUsage";
export const ADMIN_TOP_UP = "adminTopUp";
